import useUserProfile from '@/hooks/useUserProfile';
import Search from '@ui/Search';
import { ToggleButton } from '@ui/ToggleButton';
import Typography from '@ui/Typography';
import { authorizedServerFetch } from 'actions/server.actions';
import StyledContainedButton from 'components/Styled/StyledContainedButton';
import { isEmpty, sortBy, values } from 'lodash-es';
import Image from 'next/image';
import React from 'react';

function EditProfileSkillsStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, onChange, saving } =
    props;
  const [skills, setSkills] = React.useState([]);
  const [selectedSkills, setSelectedSkills] = React.useState({});
  const [searchedSkills, setSearchedSkills] = React.useState([]);
  let userData = useUserProfile();
  userData = userProfile || userData;

  const fetchSkills = async () => {
    try {
      const { data } = await authorizedServerFetch('skills');
      setSkills(sortBy(data, 'skill_title'));
    } catch (err) {
      console.log('EditProfileSkillsStep', err);
    }
  };

  const updateSelectedSkills = (selected) => {
    setSelectedSkills(selected);
    onChange(values(selected));
  };

  // fetch all skills
  React.useEffect(() => {
    fetchSkills();
  }, [userData]);

  // prepopulate the selected list
  React.useEffect(() => {
    if (userData) {
      const userSkills = {};
      userData.skills.forEach((skill) => {
        const item = skills.find((s) => s.id === skill.id);
        if (item) {
          userSkills[item.id] = item;
        }
      });
      updateSelectedSkills(userSkills);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, skills]);

  const getUpdatedSelectedList = (selectedList, item, isSelected) => {
    const newSelectedList = { ...selectedList };
    if (isSelected) {
      newSelectedList[item.id] = item;
    } else {
      delete newSelectedList[item.id];
    }
    return newSelectedList;
  };

  const handleSkillSelection = (skill, isSelected) => {
    const selected = getUpdatedSelectedList(selectedSkills, skill, isSelected);
    updateSelectedSkills(selected);
  };

  const handleSearchSkill = (searchedSkill) => {
    if (!searchedSkill || searchedSkill.length === 0) {
      setSearchedSkills(skills);
      return;
    }
    const searched = skills?.filter((skill) =>
      skill.skill_title
        .toLowerCase()
        .includes(searchedSkill.trim().toLowerCase()),
    );
    if (!isEmpty(searched)) {
      setSearchedSkills(searched);
    }
  };

  const skillsLength = Object.keys(selectedSkills).length;

  return (
    <div className="flex flex-col items-start justify-start gap-4">
      <div className="flex w-full">
        <Search
          placeholder="Search Skills"
          onChange={(val) => handleSearchSkill(val)}
        />
      </div>
      {/* <div className="flex flex-col">
        <Typography variant="h5">SKILLS ADDED BY YOU</Typography>
        <Stack
          gap={2}
          direction="row"
          flexWrap="wrap"
          className="overflow-y-auto max-h-[100px]">
          {userData.skills?.map((skill) => (
            <ToggleButton
              key={skill.id}
              label={skill.skill_title}
              selected
              disabled
              color="primary"
              onToggle={() => {}}
            />
          ))}
        </Stack>
      </div> */}
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-row justify-between">
          <div className="flex-flow-col">
            <Typography variant="h5">SELECT YOUR SKILLS</Typography>
          </div>
          <div className="mr-1 flex items-center gap-1">
            <Image
              width={12}
              height={9}
              src="/assets/images/Tick.png"
              alt="Tick"
            />
            <Typography variant="body2">{skillsLength}</Typography>
          </div>
        </div>
        <div
          // className="flex flex-row gap-4 flex-wrap"
          className="mt-3 flex max-h-[300px] flex-row flex-wrap gap-4 overflow-y-auto">
          {[...(!isEmpty(searchedSkills) ? searchedSkills : skills)]?.map(
            (skill) => (
              <ToggleButton
                key={skill.id}
                label={skill.skill_title}
                selected={
                  !!selectedSkills[skill.id] ||
                  !!userData.skills?.find(
                    (userSkill) => userSkill.id === skill.id,
                  )
                }
                color="primary"
                onToggle={(status) => handleSkillSelection(skill, status)}
              />
            ),
          )}
        </div>
      </div>
      <div className="flex-rows flex w-full justify-end gap-4 pb-4">
        {/* <div className="flex-flow-col">
          <Button
            variant="outlined"
            color="primary"
            className="mt-2"
            onClick={onBack}>
            Back
          </Button>
        </div> */}
        {true ? (
          <div className="flex-flow-col">
            <StyledContainedButton
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'Skills')}>
              Save
            </StyledContainedButton>
          </div>
        ) : (
          <div className="flex-flow-col">
            <StyledContainedButton
              disabled
              variant="outlined"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'Skills')}>
              Save
            </StyledContainedButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditProfileSkillsStep;
